import { fetcher } from 'utils/axios';
import { ChatUserModelOriginal } from 'types/chat-users/chat-user';
import {
  MassMessagingGroupDetailsItem,
  MassMessagingGroupMemberData,
  MassMessagingGroupType,
} from 'types/mass-messaging/groups';

export const fetchGetMassMessagingGroups = async () => {
  try {
    const data = await fetcher('get', '/api/massMessaging/getCompanyMassMessagingGroups', 'history');
    if (data)
      return data as {
        companyMassMessagingGroups: MassMessagingGroupType[];
        groupDetailsList: MassMessagingGroupDetailsItem[];
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in getMassMessagingGroups:', error);
    return null;
  }
};

export const fetchGetMassMessagingGroupMembers = async (groupId: number) => {
  try {
    const data = await fetcher(
      'get',
      `/api/massMessaging/getFunnerMassMessagingGroupMembers/${groupId}`,
      'history',
    );

    if (data)
      return data as {
        result: boolean;
        readyMembers: Array<{
          chatUser: ChatUserModelOriginal | null;
          memberData: MassMessagingGroupMemberData;
        }>;
      };
    else return null;
  } catch (error) {
    console.warn('Error in getMassMessagingGroupMembers:', error);
    return null;
  }
};

export const fetchCreateMassMessagingGroup = async (groupData: {
  Name: string;
  Description: string | null;
}) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/massMessaging/createFunnerMassMessagingGroup',
        {
          data: groupData,
        },
      ],
      'history',
    );

    if (data)
      return data as {
        result: boolean;
        groupId: number;
      };
    else return null;
  } catch (error) {
    console.warn('Error in createMassMessagingGroup:', error);
    return null;
  }
};

export const fetchUpdateMassMessagingGroup = async (
  id: number,
  groupData: {
    Name: string;
    Description: string | null;
  },
) => {
  try {
    const data = await fetcher(
      'post',
      [
        `/api/massMessaging/updateFunnerMassMessagingGroup/${id}`,
        {
          data: groupData,
        },
      ],
      'history',
    );

    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in updateMassMessagingGroup:', error);
    return null;
  }
};
export const fetchDeleteMassMessagingGroup = async (groupId: number) => {
  try {
    const data = await fetcher(
      'post',
      `/api/massMessaging/deleteFunnerMassMessagingGroup/${groupId}`,
      'history',
    );

    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in deleteMassMessagingGroup:', error);
    return null;
  }
};
export const fetchDuplicateMassMessagingGroup = async (groupId: number) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/massMessaging/duplicateFunnerMassMessagingGroup',
        {
          data: { id: groupId },
        },
      ],
      'history',
    );

    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in deleteMassMessagingGroup:', error);
    return null;
  }
};
export const fetchAddFunnerMassMessagingGroupMember = async (params: {
  userPhoneNumberIds: string[];
  MassMessagingGroupId: number;
}) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/massMessaging/addFunnerMassMessagingGroupMember',
        {
          data: params,
        },
      ],
      'history',
    );

    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in addFunnerMassMessagingGroupMember:', error);
    return null;
  }
};
export const fetchAppFunnerMassMessagingGroupMemberFileList = async (params: {
  users: {
    [key: string]: any;
  }[];
  MassMessagingGroupId: number;
}) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/massMessaging/addFunnerMassMessagingGroupMemberFileList',
        {
          data: params,
        },
      ],
      'history',
    );

    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in addFunnerMassMessagingGroupMemberFileList:', error);
    return null;
  }
};
export const fetchDeleteMassMessagingGroupMember = async (id: number) => {
  try {
    const data = await fetcher(
      'post',
      `/api/massMessaging/deleteFunnerMassMessagingGroupMember/${id}`,
      'history',
    );

    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in deleteFunnerMassMessagingGroupMember:', error);
    return null;
  }
};
export const fetchDeleteMassMessagingGroupMembersList = async (idlistToRemove: number[]) => {
  try {
    const data = await fetcher(
      'post',
      [
        '/api/massMessaging/deleteFunnerMassMessagingGroupMemberList',
        {
          data: { idlistToRemove },
        },
      ],
      'history',
    );

    if (data)
      return data as {
        result: boolean;
      };
    else return null;
  } catch (error) {
    console.warn('Error in deleteMassMessagingGroupMembersList:', error);
    return null;
  }
};
